export const footerMenuList = [
  // {
  //   icon: require("assets/images/login/images_01_2.png"),
  //   text: "移动课堂",
  //   path: "",
  // },
  {
    icon: require("assets/images/login/images_02_2.png"),
    text: "常见问题",
    path: "",
  },
  {
    icon: require("assets/images/login/images_03_2.png"),
    text: "联系我们",
    path: "",
  },
  {
    icon: require("assets/images/login/images_04_2.png"),
    text: "操作手册",
    path: "",
  },
  {
    icon: require("assets/images/login/images_01_2.png"),
    text: "用户协议",
    path: "",
  },
  {
    icon: require("assets/images/login/images_03_2.png"),
    text: "声明及免责条款",
    path: "",
  },
];